import { FC } from 'react'
import { SelectInput, TextInput, required, useTranslate } from 'react-admin'
import { useSimpleFormIteratorItem } from 'ra-ui-materialui'
import { useWatch } from 'react-hook-form'
import { USER_SOURCE_CHOICES } from './headerConstants'

export const ConditionalHeaderValue: FC = () => {
  const translate = useTranslate()
  const { index } = useSimpleFormIteratorItem()
  const valueType = useWatch({ name: `headers.${index}.value_type` }) as string | undefined

  if (valueType === 'custom') {
    return <TextInput source="custom_value" label="data.headerCustomValue" validate={required()} />
  }
  if (valueType === 'organization') {
    return (
      <TextInput
        source="value_source"
        label="data.headerSource"
        validate={required()}
        helperText={translate('data.orgMetadataHelp')}
      />
    )
  }
  if (valueType === 'user') {
    return (
      <SelectInput source="value_source" label="data.headerSource" choices={USER_SOURCE_CHOICES} validate={required()} />
    )
  }
  return null
}

const AuthConfigFields: FC = () => {
  const translate = useTranslate()
  const authType = useWatch({ name: 'auth_type' }) as string | undefined

  if (authType === 'custom_headers') return null

  if (authType === 'oauth_client_credentials') {
    return (
      <>
        <TextInput source="auth_config.token_url" label="data.tokenUrl" fullWidth validate={required()} />
        <TextInput source="auth_config.client_id" label="data.clientId" fullWidth validate={required()} />
        <TextInput source="auth_config.client_secret" label="data.clientSecret" fullWidth validate={required()} type="password" />
        <TextInput source="auth_config.audience" label="data.audience" fullWidth validate={required()} />
      </>
    )
  }

  if (authType === 'client_certificate') {
    return (
      <>
        <TextInput
          source="auth_config.certificate_pem"
          label="data.certificatePem"
          fullWidth
          multiline
          validate={required()}
          helperText={translate('data.certificatePemHelp')}
        />
        <TextInput
          source="auth_config.private_key_pem"
          label="data.privateKeyPem"
          fullWidth
          validate={required()}
          type="password"
          helperText={translate('data.privateKeyPemHelp')}
        />
      </>
    )
  }

  return null
}

export default AuthConfigFields
